import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { GenerateStudentAccessModalData } from '../../_models/grant-student-access/generate-student-access-modal-data.model';

/**
 * Thin dialog wrapper around the reusable <generate-student-access> widget (bug 37289).
 * All the generate-access behaviour (buttons, PIN/emoji, the proactive "fix in Orbit" cue) lives in
 * that one widget so there is a single implementation shared by the modal and inline usages.
 */
@Component({
    selector: 'generate-student-access-modal',
    templateUrl: './generate-student-access-modal.component.html',
    styleUrls: ['./generate-student-access-modal.component.css'],
    standalone: false
})
export class GenerateStudentAccessModalComponent implements OnInit {

  public studentId: number;
  public studentName: string;
  public showWebsiteLink: boolean = true;
  public showSignUpEmail: boolean = true;

  constructor(@Inject(MAT_DIALOG_DATA) public data: GenerateStudentAccessModalData) {
  }

  ngOnInit() {
    setTimeout(() => {
      this.studentId = this.data.studentId;
      this.studentName = this.data.studentName;
      this.showWebsiteLink = this.data.showWebsiteLinkButton;
      this.showSignUpEmail = this.data.showSignUpEmailButton;
    }, 0);
  }

}
